
  export const style = {
    api: {
      apiProduction: "https://cipa.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "Cipa",
      hostHeader: "cipa",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.amazonaws.com/Logos/logo_client_cipa.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.amazonaws.com/Logos/logo_secondary_client_cipa.png",
      browserLogo: "https://timcoo-geral.s3.amazonaws.com/Logos/favicon_cipa.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.amazonaws.com/Logos/logo_client_cipa.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "NOZ",
      nameScore: "Cipacoins",
      nameStore: "Cipa Store",
      nameAcademy: localStorage.getItem("nameAcademy") || "Unicipa",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#62BEED",
      secondaryColor: localStorage.getItem("secondaryColor") || "#00468F",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: false,
      customMenuItem: false,
      autoRegister: false,
      recaptchaVersion: "V1",
      showBirthday: "true"
    },
  };
